window.GeminiSubaccountsIntegration = {}